module.exports = __webpack_public_path__ + "img/107ne.d75a086f.svg";